const LION_HOSTNAMES = ["lionsend.site", "lionsend.com", "lionbulk.site"];

export const getAppTheme = (hostname = window.location.hostname) => {
    const normalizedHostname = hostname.toLowerCase().replace(/^www\./, "");

    return LION_HOSTNAMES.includes(normalizedHostname) ? "lion" : "classic";
};
